const webAddresses = {
  termsAndConditions: {
    href: "https://www.doublestruck.co.uk/terms-and-conditions/",
    name: "terms and conditions"
  },
  privacyStatement: {
    href: "https://www.doublestruck.co.uk/privacy-statement/",
    name: "privacy statement"
  },
  cookiePolicy: {
    href: "https://www.doublestruck.co.uk/cookie-policy/",
    name: "cookie policy"
  },
  gdpr: {
    href: "https://www.doublestruck.co.uk/gdpr/",
    name: "GDPR"
  }

};


export { webAddresses };
